<template>
    <ReportExplanationStatistics :summary="statistics" :loading="loading" :error="error" :kind="kind" :reason-key="reasonKey" @retry="loadStatistics" />
</template>
<script>
import api from '@/store/ShiftReport/api/index';
import ReportExplanationStatistics from './ReportExplanationStatistics.vue';
export default {
    name: 'ReportExplanationStatisticsPanel',
    components: {ReportExplanationStatistics},
    props: {kind: String, reasonKey: String},
    data: () => ({statistics: null, loading: false, error: '', request: 0}),
    computed: {
        identity() {
            const user = this.$store.getters.currentUser || {};
            return user.company && (user.userId || user.id) ? JSON.stringify([user.company, user.userId || user.id]) : '';
        }
    },
    watch: {identity: {immediate: true, handler() { this.loadStatistics(); }}},
    beforeDestroy() { this.request++; },
    methods: {
        async loadStatistics() {
            const request = ++this.request, identity = this.identity;
            this.statistics = null; this.error = ''; this.loading = false;
            if (!identity) return;
            this.loading = true;
            try {
                const result = await api.getExplanationStatistics();
                if (request === this.request && identity === this.identity) this.statistics = result;
            } catch (error) {
                if (request === this.request && identity === this.identity) this.error = 'Не удалось загрузить статистику. Это не мешает подаче отчёта.';
            } finally {
                if (request === this.request && identity === this.identity) this.loading = false;
            }
        }
    }
};
</script>
